import React from 'react';
import Icon from '../../../components/AppIcon';
import { Checkbox } from '../../../components/ui/Checkbox';
import Button from '../../../components/ui/Button';

const FilterPanel = ({ 
  filters, 
  onFilterChange, 
  onApplyFilters, 
  onResetFilters,
  questionCount,
  isOpen,
  onClose 
}) => {
  const knowledgeAreas = [
    { id: 'business-analysis-planning', label: 'Business Analysis Planning and Monitoring', count: 18500 },
    { id: 'elicitation-collaboration', label: 'Elicitation and Collaboration', count: 22000 },
    { id: 'requirements-lifecycle', label: 'Requirements Life Cycle Management', count: 19500 },
    { id: 'strategy-analysis', label: 'Strategy Analysis', count: 16000 },
    { id: 'requirements-analysis', label: 'Requirements Analysis and Design Definition', count: 24000 },
    { id: 'solution-evaluation', label: 'Solution Evaluation', count: 20000 }
  ];

  const difficultyLevels = [
    { id: 'beginner', label: 'Beginner', count: 35000 },
    { id: 'intermediate', label: 'Intermediate', count: 50000 },
    { id: 'advanced', label: 'Advanced', count: 35000 }
  ];

  const questionTypes = [
    { id: 'scenario-based', label: 'Scenario-Based', count: 85000 },
    { id: 'definition', label: 'Definition', count: 20000 },
    { id: 'application', label: 'Application', count: 15000 }
  ];

  const answerStatus = [
    { id: 'unanswered', label: 'Unanswered Only', count: 0 },
    { id: 'incorrect', label: 'Previously Incorrect', count: 0 },
    { id: 'bookmarked', label: 'Bookmarked', count: 0 }
  ];

  const handleCheckboxChange = (category, itemId) => {
    const currentSelection = filters?.[category] || [];
    const newSelection = currentSelection?.includes(itemId)
      ? currentSelection?.filter(id => id !== itemId)
      : [...currentSelection, itemId];
    
    onFilterChange(category, newSelection);
  };

  const FilterSection = ({ title, items, category }) => (
    <div className="mb-6">
      <h3 className="text-sm font-semibold text-foreground mb-3 flex items-center gap-2">
        <Icon name="Filter" size={16} />
        {title}
      </h3>
      <div className="space-y-2">
        {items?.map(item => (
          <div key={item?.id} className="flex items-center justify-between">
            <Checkbox
              label={item?.label}
              checked={filters?.[category]?.includes(item?.id) || false}
              onChange={() => handleCheckboxChange(category, item?.id)}
              size="sm"
            />
            <span className="text-xs text-muted-foreground data-text">
              {item?.count?.toLocaleString()}
            </span>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className={`bg-card border-r border-border h-full overflow-y-auto ${isOpen ? 'block' : 'hidden'} lg:block`}>
      <div className="p-4 md:p-6 sticky top-0 bg-card border-b border-border z-10">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold text-foreground">Filters</h2>
          <button
            onClick={onClose}
            className="lg:hidden p-2 hover:bg-muted rounded-lg transition-colors"
            aria-label="Close filters"
          >
            <Icon name="X" size={20} />
          </button>
        </div>
        
        <div className="bg-primary/10 rounded-lg p-3 border border-primary/20">
          <div className="flex items-center gap-2 mb-1">
            <Icon name="Database" size={16} className="text-primary" />
            <span className="text-xs font-medium text-primary">Available Questions</span>
          </div>
          <p className="text-2xl font-bold text-primary data-text">
            {questionCount?.toLocaleString()}
          </p>
        </div>
      </div>
      <div className="p-4 md:p-6">
        <FilterSection 
          title="Knowledge Areas" 
          items={knowledgeAreas} 
          category="knowledgeAreas"
        />
        
        <FilterSection 
          title="Difficulty Level" 
          items={difficultyLevels} 
          category="difficulty"
        />
        
        <FilterSection 
          title="Question Type" 
          items={questionTypes} 
          category="questionTypes"
        />
        
        <FilterSection 
          title="Answer Status" 
          items={answerStatus} 
          category="answerStatus"
        />

        <div className="flex flex-col gap-3 mt-6 pt-6 border-t border-border">
          <Button
            variant="default"
            fullWidth
            onClick={onApplyFilters}
            iconName="Play"
            iconPosition="left"
          >
            Start Practice
          </Button>
          <Button
            variant="outline"
            fullWidth
            onClick={onResetFilters}
            iconName="RotateCcw"
            iconPosition="left"
          >
            Reset Filters
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;